<template>
    <div class="restaurant-details-loaders">
      <div class="wrapper">
          <div class="circle"></div>
          <div class="line-1"></div>
          <div class="line-2"></div>
          <div class="line-3"></div>
          <div class="line-4"></div>
          <div class="line-5"></div>
          <div class="line-6"></div>
      </div>
      </div>
  </template>
  
  <script>
  export default {
      name: 'RestaurantDetailLoader'
  }
  </script>
  
  <style>
  @media only screen and (max-width: 800px){
    .restaurant-details-loaders {
        position: relative;
        width: 125%;
        height: 130px;
        padding: 15px;
        background-color: #f7f7f7;
        overflow: hidden;
        margin: 0px 5px;
        border-radius: 10px;
        -webkit-box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.14);
                box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.14);
        margin-top: -120px;
        z-index: 1;
    }
  }

  @media (min-width: 800px) {
    .restaurant-details-loaders {
        position: relative;
        width: 98%;
        height: 200px;
        padding: 15px;
        background-color: #f7f7f7;
        overflow: hidden;
        margin: 0px 5px;
        border-radius: 10px;
        -webkit-box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.14);
                box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.14);
        margin-top: -80px;
    }
  }
  
  .restaurant-details-loaders:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(120deg, rgba(227, 227, 227, 0) 0%, rgba(227, 227, 227, 0) 40%, rgb(255, 255, 255) 50%, rgba(227, 227, 227, 0) 60%, rgba(227, 227, 227, 0) 100%);
    animation: gradient-animation_2 1s linear infinite;
  }
  
  .restaurant-details-loaders .wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .restaurant-details-loaders .wrapper > div {
    background-color: #ececec;
    background-image: -webkit-linear-gradient(left, #ececec 0px, #ddd 40px, #ececec 80px);
    background-image: -o-linear-gradient(left, #ececec 0px, #ddd 40px, #ececec 80px);
    background-image: linear-gradient(90deg, #ececec 0px, #ddd 40px, #ececec 80px);
    border-radius: 30px;
  }
  
  .restaurant-details-loaders .button {
    display: inline-block;
    height: 32px;
    width: 75px;
  }

  .restaurant-details-loaders .circle {
    position: absolute;
    top: 7px;
    width: 35px;
    height: 35px;
    left: 0px;
    border-radius: 50%;
  }
  
  .restaurant-details-loaders .line-1 {
    position: absolute;
    top: 11px;
    left: 15%;
    height: 7px;
    width: 100px;
  }
  
  .restaurant-details-loaders .line-2 {
    position: absolute;
    top: 34px;
    left: 15%;
    height: 7px;
    width: 70px;
  }
  
  .restaurant-details-loaders .line-3 {
    position: absolute;
    top: 67px;
    left: 0px;
    height: 7px;
    width: 50%;
  }

  .restaurant-details-loaders .line-4 {
    position: absolute;
    top: 67px;
    left: 70%;
    height: 7px;
    width: 25%;
  }

  .restaurant-details-loaders .line-5 {
    position: absolute;
    top: 90px;
    left: 0;
    height: 7px;
    width: 40%;
  }

  .restaurant-details-loaders .line-6 {
    position: absolute;
    top: 90px;
    left: 70%;
    height: 7px;
    width: 25%;
  }

  @keyframes gradient-animation_2 {
    0% {
      transform: translateX(-100%);
    }
  
    100% {
      transform: translateX(100%);
    }
  }
  </style>